module.exports = __webpack_public_path__ + "img/gg.8fbd413f.png";